import type { Observable } from 'rxjs';
import { useTheme } from 'styled-components';
import { useHistoricalPrices, useIntl } from '../../../hooks';
import type { MarketDataSnapshot, Security } from '../../../types';
import { FormGroup } from '../../DateTimeDurationPicker/styles';
import { Text } from '../../Text';
import { getLimitAndDescription, MarketView } from '../../VolumeLadder/MarketView';
import type { ClickRowCallback } from '../../VolumeLadder/types';

const resolution = '1H';

export function OrderFormMarketView({
  marketDataSnapshots,
  onClickRow,
  security,
  viewType,
}: {
  marketDataSnapshots: Observable<MarketDataSnapshot>;
  onClickRow: ClickRowCallback;
  security?: Security;
  viewType: 'rfq' | 'order' | undefined;
}) {
  const sparklineDataObservable = useHistoricalPrices({
    symbol: security?.Symbol,
    resolution,
  });

  const { spacing8, spacing16 } = useTheme();
  const intl = useIntl();

  return (
    <FormGroup
      style={{ position: 'relative', margin: `0 0 ${spacing16}px`, display: viewType === 'rfq' ? 'none' : undefined }}
    >
      <MarketView
        marketDataObservable={marketDataSnapshots}
        onClickRow={onClickRow}
        resolution={resolution}
        security={security}
        sparklineDataObservable={sparklineDataObservable}
        showReferenceLines={false}
      />
      <Text fontSize="fontSizeXs" style={{ position: 'absolute', top: 0, right: 0, padding: spacing8 }}>
        {getLimitAndDescription(resolution, intl).description}
      </Text>
    </FormGroup>
  );
}
